import React from 'react';
import { PromoCodeStyledAP } from './AP/PromoCodeStyled.AP';
import { PromoCodeStyledAC } from './AC/PromoCodeStyled.AC';
import { PromoCodeStyledDS } from './DS/PromoCodeStyled.DS';
import { PromoCodeStyledOV } from './OV/PromoCodeStyled.OV';
import { PromoCodeStyledOV as PromoCodeStyledOV_GB } from './OV/GB/PromoCodeStyled.OV';
import { PromoCodeStyled } from './PromoCodeStyled';
import { SC } from '../../styles/theme';
import { isBrandAC, isBrandAP, isBrandDS, isBrandOV, isMarketGB } from '../../constants/main';
import { Pages } from '../../types/pages';

export type PromoCodeProps = SC & {
    showTitle?: boolean;
    noPadding?: boolean;
    validateSelectedPaymentMethod?: boolean;
    page?: Pages;
};

const PromoCode = (props: PromoCodeProps) => {
    if (isBrandAP) return <PromoCodeStyledAP {...props} />;
    if (isBrandAC) return <PromoCodeStyledAC {...props} />;
    if (isBrandDS) return <PromoCodeStyledDS {...props} />;
    if (isBrandOV) return isMarketGB ? <PromoCodeStyledOV_GB {...props} /> : <PromoCodeStyledOV {...props} />;
    return <PromoCodeStyled {...props} />;
};

export default PromoCode;
